import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {StoreItem, StoreItemDeleteInput, StoreItemEntity, StoreItemFiltering, StoreItemInput} from './store-item.model';
import {PageResult} from "../../../common/interfaces/global-interfaces";

export const StoreItemActions = createActionGroup({
  source: 'StoreItem/API',
  events: {
    'Load StoreItems': props<{ storeItems: StoreItem[], entity: StoreItemEntity }>(),
    'Set StoreItem Pagination': props<{ page: PageResult, entity: StoreItemEntity }>(),
    'Add StoreItem': props<{ storeItem: StoreItem }>(),
    'Upsert StoreItem': props<{ storeItem?: StoreItem | StoreItem[], entity: StoreItemEntity }>(),
    'Add StoreItems': props<{ storeItems: StoreItem[] }>(),
    'Upsert StoreItems': props<{ storeItems: StoreItem[] }>(),
    'Update StoreItem': props<{ storeItem: Update<StoreItem> }>(),
    'Update StoreItems': props<{ storeItems: Update<StoreItem>[] }>(),
    'Delete StoreItem': props<{ id: string, entity: StoreItemEntity }>(),
    'Delete StoreItems': props<{ ids: string[] }>(),
    'Clear StoreItems': emptyProps(),

    // Effects actions
    'CreateUpdateStoreItem': props<StoreItemInput>(),
    'removeStoreItem': props<StoreItemDeleteInput>(),
    'GetStoreItems':  props<StoreItemFiltering>(),
    'GetStoreItemsMergeMap':  props<StoreItemFiltering>(),
  }
});
